export default __webpack_public_path__ + "static/media/stage-6-neocortex-primary-and-secondary.ef149f3c.png";